/**
 * useVendorAuth Hook
 * Convenience hook for accessing vendor authentication state
 * Sprint 4G: Created for PayoutsPage
 */

import { useAuthStore } from '@/store/auth';

export function useVendorAuth() {
  const { isAuthenticated, user, vendor, isLoading } = useAuthStore();

  return {
    isAuthenticated,
    user,
    vendor,
    isLoading,
    vendorId: vendor?.id || null,
  };
}

